<template lang="html">

    <v-card raised
            class="mb-5 payment-form"
            color="rgb(247, 247, 247)"
    >

      <v-card-title primary-title>
        <div>
          <h3 class="headline mb-0">Make Payment</h3>
        </div>
      </v-card-title>

      <v-container v-show="working" style="background-color: white">

        <v-flex>
          <img style="max-width: 100%" src="../assets/processingPayment.gif"/>
        </v-flex>

      </v-container>
      <v-tabs v-show="!working" fixed-tabs
               show-arrows
               v-model="activePaymentType"
               color="#1976d2"
               dark
               slider-color="white"
      >
        <v-tab
                key="1"
                ripple              >
          <v-icon style="margin-right: 10px">fa-credit-card</v-icon>
          Credit Card

        </v-tab>
        <v-tab
                key="2"
                ripple
        >
          <v-icon style="margin-right: 10px">fa-money-check</v-icon>
          E-Check

        </v-tab>

        <v-tab
                v-if="!hidefr"
                key="3"
                ripple
        >
          <v-icon style="margin-right: 10px">fa-piggy-bank</v-icon>
          Fundraising/Adjustments

        </v-tab>

        <v-tab
                v-if="!hidemfr"
               key="4"
               ripple
        >
          <v-icon style="margin-right: 10px">fa-piggy-bank</v-icon>
          Manual

        </v-tab>



        <v-tab-item
                key="1"
        >

          <v-container fluid>

            <v-layout row>
              <v-flex xs4 v-if="1==2">
                <v-subheader>Card</v-subheader>
              </v-flex>
              <v-flex xs12>
                <VCreditCard yearDigits=4 :noCard="isIE" ref="vCreditCard"/>
                <br/>
              </v-flex>
            </v-layout>



            <v-layout row>
              <v-flex xs4>
                <v-subheader>Amount</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        label="Payment Amount"
                        type="number"
                        v-model="paymentAmount"
                        @blur="amountChange"
                        prefix="$"
                ></v-text-field>
              </v-flex>
            </v-layout>



          </v-container>
        </v-tab-item>

        <v-tab-item
                key="2"
        >
          <v-container fluid>
            <v-layout row>
              <v-flex xs4>
                <v-subheader>Name</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        v-validate="'required'"
                        v-model="billingName"
                        label="Name on account"
                        required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs4>
                <v-subheader>Routing number</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        v-validate="'required'"
                        v-model="check.routing"
                        type="number"
                        label="Routing #"
                        required
                ></v-text-field>
              </v-flex>
            </v-layout>

            <v-layout row>
              <v-flex xs4>
                <v-subheader>Account number</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        v-validate="'required'"
                        v-model="check.account"
                        type="number"
                        label="Acct #"
                        required
                ></v-text-field>
              </v-flex>
            </v-layout>



            <v-layout row>
              <v-flex xs4>
                <v-subheader>Amount</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        label="Payment Amount"
                        type="number"
                        v-model="paymentAmount"
                        @blur="amountChange"
                        prefix="$"
                ></v-text-field>
              </v-flex>

            </v-layout>

            <v-layout row>

              <v-flex xs12>
                <p style="color: #df0a0a; font-weight: 600;">Please type your account number in correctly. If you fail to do so or you have insufficient funds, you will be charged a $25.00 check return fee.</p>
              </v-flex>
            </v-layout>


          </v-container>
        </v-tab-item>


        <v-tab-item
                key="3"
                v-if="!hidefr"
        >
          <v-container fluid>

            <v-layout row>
              <v-flex xs4>
                <v-subheader>Add Fundraising</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        label="Payment Amount"
                        type="number"
                        v-model="paymentFundraisingAmount"
                        prefix="$"
                ></v-text-field>
              </v-flex>
            </v-layout>
            <v-layout row>
              <v-flex xs12>

                <p><b>Shouldn't be used to affect remaining trip cost. Use adjustments</b></p>
                <p>Shows up in payment history as type "Fundraising" visible to the customer/director</p>
              <p>This adds fundraising without a transaction (for example adding fundraising processed from authorize.net directly).
                </p>
              </v-flex>
            </v-layout>

            <br/>
            <v-divider></v-divider>
            <br/>

            <v-layout row>
              <v-flex xs4>
                <v-subheader>Add Adjustment</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        label="Payment Amount"
                        type="number"
                        v-model="paymentAdjustmentAmount"
                        prefix="$"
                ></v-text-field>

              </v-flex>
            </v-layout>
            <v-layout row wrap >
              <v-flex xs12>

                <p><b>Shouldn't be used for fundraising. Use above.</b></p>
                <p>Shows up in payment history as type "Adjustment" visible to the customer/director</p>

              <p>If positive (for example adding payment processed from authorize.net directly), acts as a payment and lowers remaining cost.</p>

                <p>If negative (for example a refund), it increases remaining cost.</p>


                <br/>
                <v-divider></v-divider>
                <br/>


                <p><b>Adjustments/Fundraising stacks.</b> If you make a mistake and adjust -100 just make another adjustment of 100.</p>

                <br/>
                <br/>
              </v-flex>
              <v-flex xs2></v-flex>
              <v-flex xs8 >
                <v-text-field
                    label="Note to Customer (this is included in email to customer) (50 character limit)"
                    maxlength="50"
                    hide-details
                    v-model="paymentNotes"
                ></v-text-field>
                <v-checkbox  v-model="sendAdjustmentEmail" label="Send email to customer about adjustment"
                             hide-details >Test</v-checkbox>
              </v-flex>
              <v-flex>

              </v-flex>
            </v-layout>



          </v-container>
        </v-tab-item>



        <v-tab-item
                key="4"
                v-if="!hidemfr"
        >
          <v-container fluid>

            <h3>Add Processed Payment Manually</h3>
            <br/>

            <v-layout row>
              <v-flex xs4>
                <v-subheader>Billing Name</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        v-validate="'required'"
                        v-model="billingName"
                        label="Name on account"
                        required
                ></v-text-field>
              </v-flex>
            </v-layout>


            <v-layout row>
              <v-flex xs4>
                <v-subheader>{{this.massAdjustment ? 'Adjustment Notes' : 'Transaction Number'}}</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        v-validate="'required'"
                        v-model="manual.ref"
                        :label="this.massAdjustment ? 'Visible To Customer' : 'Ref #'"
                        required
                ></v-text-field>
              </v-flex>
            </v-layout>



            <v-layout row>
              <v-flex xs4>
                <v-subheader>Amount</v-subheader>
              </v-flex>
              <v-flex xs8>
                <v-text-field
                        label="Payment Amount"
                        type="number"
                        v-model="paymentAmount"
                        @blur="amountChange"
                        prefix="$"
                ></v-text-field>
              </v-flex>
            </v-layout>

          </v-container>
        </v-tab-item>


      </v-tabs>

      <p style="color: red">{{error}}</p>
      <p style="color: red">{{paymentError}}</p>


      <v-btn v-show="!working" :disabled = "invalidPaymentEntry"
             color="primary"
             @click="MakePayment"
      >
        Submit Payment
      </v-btn>
    </v-card>


</template>

<script lang="js">
    import VCreditCard from 'v-credit-card';
    import 'v-credit-card/dist/VCreditCard.css';
  export default  {
    name: 'payment-form',
    props: ["participant", "massFundraising", "massAdjustment", "hidefr", "hidema", "minPayment","defaultMinPayment","maxPayment", "initialPayment"],
      components: {
         // CreditCardField: () => import(/* webpackChunkName: "vue-credit-card-field" */'vue-credit-card-field/src/Components/CreditCardField')
          VCreditCard
      },
      mounted() {
          this.billingName = this.$userData.firstName + ' ' +  this.$userData.lastName
          this.amountChange()

          this.$refs.vCreditCard.form.name = this.billingName

          this.$watch(() => this.$refs.vCreditCard.form.name, (value) => { this.billingName = value;})
          this.$watch(() => this.$refs.vCreditCard.form.cardNumber, (value) => {this.card.number = value.replace(/ /g, '');})
          this.$watch(() => this.$refs.vCreditCard.form.security, (value) => { this.card.cvc = value;})
          this.$watch(() => this.$refs.vCreditCard.form.expiration, (value) => {
              this.card.expMonth = value.split("/")[0];
              this.card.expYear = value.split("/")[1];
          })

      },
    data() {
      return {
          activePaymentType: this.massAdjustment ? 2 : 0,
          billingName: '',
          paymentNotes: '',
        sendAdjustmentEmail: true,
          paymentAdjustmentAmount: 0,
          paymentFundraisingAmount: 0,
          paymentAmount: this.initialPayment,
          card: {
              number: null,
              cvc: null,
              expMonth: null,
              expYear: null
          },
          check: {},
          manual: {},
          paymentError: '',
          error: '',
          working: false
      }
    },
      methods: {
          amountChange() {
            console.log('payment amount', parseFloat(this.paymentAmount))
            console.log('max payment', this.maxPayment)
              if (parseFloat(this.paymentAmount) > this.maxPayment) {
                  this.$nextTick(() => {
                      this.paymentAmount = this.maxPayment
                      this.error = "Amount entered cannot be over $" + this.maxPayment
                  })
              } else if (parseFloat(this.paymentAmount) < this.minPayment) {
                  this.$nextTick(() => {
                      this.paymentAmount = this.minPayment
                      this.error = "Amount entered must be at least $" + this.minPayment
                  })
              } else if (this.maxPayment -this.paymentAmount != 0 && this.maxPayment -this.paymentAmount <  this.defaultMinPayment) {
                  this.$nextTick(() => {
                      this.error = "Amount entered would leave only $" + (this.maxPayment - this.paymentAmount) + " remaining"
                  })
              } else {
                  this.error = ''
              }
          },
          MakePayment() {
              var vueThis = this;

            this.working = true
              var completedPariticpants = 0
              var remainingToDivide = Number(this.paymentAmount)

              console.log('participants defined as', vueThis.participant)
              var builtParticipants = []
              var successMessage = ''

              if(vueThis.participant.length == 1) {
                  successMessage = ' To Traveler: ' + vueThis.participant[0].fullName
              } else if(this.massFundraising) {
                  successMessage = ' To Fundraising'
              } else {
                  successMessage = ' Divided amongst your participants'
              }

              vueThis.participant.forEach((participant)=>{

                  var toAdd = {}
                  toAdd.ParticipantID = participant._id
                  toAdd.TripID = participant.TripID
                  toAdd.TripIDNumber = participant.Trip.tripID
                  toAdd.ParticipantName = participant.fullName
                  toAdd.ParentUser = participant.ParentUser

                  if(participant.fundraisingToApply != undefined) {
                      toAdd.Amount =  Number(participant.fundraisingToApply)
                  } else {

                      if(this.paymentAdjustmentAmount != 0) {
                          toAdd.Amount = Number(this.paymentAdjustmentAmount)
                      }
                      else if (this.paymentFundraisingAmount != 0) {
                          toAdd.Amount =Number(this.paymentFundraisingAmount)

                      } else if(vueThis.participant.length == 1) {
                          toAdd.Amount = Number(this.paymentAmount)
                      } else {
                          var amount = remainingToDivide / (vueThis.participant.length - completedPariticpants)
                          if(amount > participant.maxPayment) {
                              toAdd.Amount =  Number(participant.maxPayment)
                          } else {
                              toAdd.Amount =  amount
                          }

                          remainingToDivide = remainingToDivide - toAdd.Amount

                      }


                  }

                  builtParticipants.push(toAdd)

                  completedPariticpants++

              })



              console.log('built parts', builtParticipants)

              this.error = ''
              this.paymentError = ''
              console.log('making payment for!!!!!!!!', this.card, this.paymentAmount)

              var authData = {};

              authData.clientKey = "3Tkm67RgHUxp95mDW5BZ9XC3H37P3G6ktbcd7rtwm4AGQEye45e5VnA2e45WDhPr";
              authData.apiLoginID = "98rLDa4ua";

            if (location.hostname === "localhost" || location.hostname === "127.0.0.1") {
              authData.clientKey = "5H82976xux293w2FYC36FS2smp3c4rM27BgH6K4x2f43JPXqbJ3zYqje6ZArQuKu";
              authData.apiLoginID = "43qaXMT6f4x";
            }

              var cardData = {};
              var bankData = {};
              var secureData = {};
              secureData.authData = authData;

              if (this.activePaymentType == 0) {
                  cardData.cardNumber = this.card.number;
                  cardData.month = this.card.expMonth;
                  cardData.year = this.card.expYear;
                  cardData.cardCode = this.card.cvc;

                  secureData.cardData = cardData;

              } else if (this.activePaymentType == 1) {
                  bankData.accountNumber = this.check.account;
                  bankData.routingNumber = this.check.routing
                  bankData.nameOnAccount = this.billingName.trim()
                  bankData.accountType = "checking";


                  secureData.bankData = bankData;
              } else if (this.activePaymentType == 2) {

              }

              if (this.activePaymentType != 2) {
                  Accept.dispatchData(secureData, (response) => {
                      console.log(response, response.messages.resultCode, response.messages.resultCode === "Error")
                      if (response.messages.resultCode === "Error") {
                          console.log('response was an error')
                          this.paymentError = response.messages.message[0].text
                          this.working = false
                      } else {
                          var type = ((this.activePaymentType == 0) ? 'Credit Card' : 'E-Check')


                          if(this.massFundraising) {
                              type = "Fundraising"
                          }

                          this.$services.payments.create({
                            //  "ParticipantID": this.participant._id,
                              "Participants": builtParticipants,
                           //   "InvoiceNumber" :
                              "BillingName": this.billingName,
                              "BillingEmail": vueThis.$userData.email,
                              "TransToken": response.opaqueData.dataValue,
                              "Last4": ((this.activePaymentType == 0) ? this.card.number.slice(-4) : this.check.account.slice(-4)),
                           //   "Amount": Number(this.paymentAmount),
                              "Date": new Date(),
                              "PayingUser": vueThis.$userData._id,
                              "Type": type,
                          }).then((result) => {
                              console.log('heard back...', result)
                              console.log('part', vueThis.participant)
                              vueThis.$addPayment(result)

                            if(result.Status == 'Pending') {
                              vueThis.$emit("alertUser", "warning", "Your payment of $" + Number(vueThis.paymentAmount).toFixed(2) + " is pending")
                            } else {
                              vueThis.$emit("alertUser", "success", "Applied $" + Number(vueThis.paymentAmount).toFixed(2)  +
                                  successMessage)
                            }


                              vueThis.working = false
                              vueThis.$router.push('/')
                              // vueThis.e1++
                          }).catch((error) => {
                              vueThis.working = false
                              vueThis.paymentError = error.message
                          })
                      }
                  });

          }

              else if (this.activePaymentType == 2 && (!this.massFundraising || !this.massAdjustment)) {
                  let type = ''
                  let amount = 0

                  if(this.paymentAdjustmentAmount != 0) {
                      amount = this.paymentAdjustmentAmount
                      type = "Adjustment"
                  }
                  else if (this.paymentFundraisingAmount != 0) {
                      amount = this.paymentFundraisingAmount
                      type = "Fundraising"
                  }



                  this.$services.payments.create({
                      "Participants": builtParticipants,
                      "BillingName": this.billingName,
                      "Last4": '****',
                      "Date": new Date(),
                      "PayingUser": vueThis.$userData._id,
                      "Type": type,
                      "SkipTrans" : true,
                      "SendNotification" : this.sendAdjustmentEmail,
                      "Notes" : this.paymentNotes
                  }).then((result) => {
                      console.log('heard back', result)
                      console.log('part', vueThis.participant)
                      vueThis.$addPayment(result)
                      vueThis.$emit("alertUser", "success", "Applied $" + Number(amount).toFixed(2) + " To Traveler: " +
                          vueThis.participant[0].fullName)
                      this.working = false
                      // vueThis.e1++
                  }).catch((error) => {
                      this.error = error
                      this.working = false
                  })
              }
              else if (this.activePaymentType == 2  && (this.massFundraising || this.massAdjustment)) {
                  let amount = this.paymentAmount
                  let type = "Fundraising"

                if(this.massAdjustment)
                  type="Adjustment"

                  this.$services.payments.create({
                      "Participants": builtParticipants,
                      "BillingName": this.billingName,
                      "Last4": '****',
                      "Date": new Date(),
                      "PayingUser": vueThis.$userData._id,
                      "Type": type,
                      "SkipTrans" : true,
                      'Notes': this.manual.ref
                  }).then((result) => {
                      console.log('heard back', result)
                      console.log('part', vueThis.participant)
                      vueThis.$addPayment(result)
                      vueThis.$emit("alertUser", "success", "Applied $" + Number(amount).toFixed(2))
                      this.working = false
                      vueThis.$router.push('/')
                      // vueThis.e1++
                  }).catch((error) => {
                      this.error = error
                      this.working = false
                  })
              }

          }

      },
    computed: {
        isIE() {
            return (navigator.userAgent.indexOf('MSIE') !== -1 || navigator.appVersion.indexOf('Trident/') > 0)
        },
        hidemfr() {
            if(this.massFundraising != true || !(this.$userData.permissions.includes('admin')  || this.$userData.permissions.includes('sales') )) {
                return true
            } else {
                return false
            }
        },
        invalidPaymentEntry() {
            console.log(this.billingName.split(' ').length)
            if(this.billingName.split(' ').length < 2) {
                this.error = 'Please enter your full name'
                return true
            } else if(this.error == 'Please enter your full name') {
                this.error = ''
                console.log('case 0')
            }
            if(this.activePaymentType == 2 && (this.massFundraising || this.paymentAdjustmentAmount != 0 || this.paymentFundraisingAmount != 0)) {
                return false;
            }
//|| (this.maxPayment -this.paymentAmount != 0 && this.maxPayment -this.paymentAmount <  this.defaultMinPayment)
            if(this.paymentAmount > this.maxPayment || this.paymentAmount < this.minPayment
                ) {
                console.log('case 2')
                return true
            }

            if (this.card != undefined && this.card.number != null && this.card.number.length > 14 && this.billingName.trim().indexOf(' ') != -1
                && this.card.expMonth != null && this.card.expYear != null && this.card.expMonth.length > 1 && this.card.expYear.length > 3
                && this.card.cvc != null && this.card.cvc.length > 2) {
                this.error = ''
                return false

            }  else if (this.check.routing != undefined && this.check.account != undefined && this.billingName.trim().indexOf(' ') != -1 &&
                this.check.routing > 1000 && this.check.account > 1000) {
                return false
            } else if (this.activePaymentType == 3) {
                return false
            } else if (this.activePaymentType == 1) {
                this.error==''
                return true
            } else if(this.activePaymentType != 1) {

                if (this.card.number != null && this.card.number.length < 15) {
                    this.error = 'Valid credit card number required'
                    return true

                } else if (this.card.expMonth != null && this.card.expYear != null &&
                    (this.card.expMonth.length < 2 || this.card.expYear.length < 4)) {
                    this.error = 'Expiration must be in the format mm/yyyy for example 06/2020'
                    return true

                } else if (this.card.cvc != null && this.card.cvc.length < 3) {
                    this.error = 'cvc code must be at least 3 digits'
                    return true

                } else if (this.card.cvc == null) {
                    this.error = ''
                    return true

                }
            } else {
                console.log('case 3',this.card)
                return true
            }
        }
    }
}
</script>

<style  lang="scss">
  .credit-card-form {
    padding: 0px !important;
  }
  .credit-card-form .field {
    text-align: left !important;
  }
  .credit-card-field.has-errors .invalid-feedback {
    display: none !important;
  }
</style>
